/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([
	'jquery',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'text!./templates/ForecastIndicator.html',
	'../../../lib/@waca/core-client/js/core-client/utils/Utils',
	'./ForecastFlyoutView',
	'../../../lib/@waca/dashboard-common/dist/utils/Flyout',
	'doT',
	'../../../widgets/livewidget/nls/StringResources',
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/utils/EventChainLocal'
], function($, Class, forecastIndicatorTemplate, Utils, FlyoutView, Flyout, dot, resources, _, EventChainLocal) {
	'use strict';

	const fcTemplate = dot.template(forecastIndicatorTemplate);

	const ForecastIndicator = Class.extend({
		init: function(options){
			this.visModel = options.visModel;
			this.ownerWidget = options.ownerWidget;
			this.supportsForecasts = options.supportsForecasts;
			this.eventRouter = options.ownerWidget.eventRouter;
			this.visAPI = options.visAPI;
			this.content = options.content;

			const forecastIcon = this.ownerWidget.dashboardApi.getFeature('Icons').getIcon('forecast');
			this.$forecastIndicator = $(fcTemplate({
				title: resources.get('forecast_title'),
				forecastIcon: forecastIcon.id
			}));

			this.$forecastIndicator = Utils.embedSVGIcon(this.$forecastIndicator);
			this.logger = options.logger;
			this.ownerView = options.ownerView;
		},

		initEvents: function() {
			var onclick = this._onClick.bind(this);
			this.$forecastIndicator.on('tap keydown click', onclick);
			this.update();
		},

		update: function() {
			// There is a hidden style on the indicator unless there actually is an overflow.
			if (this._areThereValidForecastMessages()) {
				this.$forecastIndicator.removeClass('liveWidgetForecastNone');
			} else {
				this.$forecastIndicator.addClass('liveWidgetForecastNone');
			}
		},

		_areThereValidForecastMessages: function() {
			if (!this.ownerView.supportsForecasts() || !this.content) {
				return false;
			} else {
				return this.content.getFeature('Forecast').areThereValidForecastSettings();
			}

		},

		getIndicator: function() {
			return this.$forecastIndicator;
		},

		_onClick: function(evt) {
			new EventChainLocal(evt).setProperty('preventDefaultContextBar', true);

			if (evt.keyCode && evt.keyCode !== 13) {
				// Keypress and it is not enter.. ignore
				return;
			}

			if (evt.gesture) {
				// prevent the virtual click event from firing. Otherwise this method will be called twice.
				evt.gesture.preventDefault();
			}

			if (!this.flyout) {
				const uniqueId = _.uniqueId('ForecastIndicatorPopover');

				this.flyout = new Flyout({
					container: document.body,
					selector: this.$forecastIndicator,
					popoverClass: 'forecastPopover visTopPopover ' + uniqueId,
					viewport: this.el,
					viewClass: FlyoutView,
					placement: 'left',
					viewOptions: {
						visAPI: this.visModel,
						uniqueId: uniqueId,
						content: this.content
					},
					logger: this.logger
				});
				if (this.eventRouter) {
					this.eventRouter.on('widget:hideToolbar', this.closeFlyout, this);
				}
			}
			this.flyout.open(this.$forecastIndicator);
		},

		closeFlyout: function() {
			this.flyout.close();
		}

	});

	return ForecastIndicator;
});
